export var TOURLANE_DOMAINS = ['tourlane.co.uk', 'tourlane.com', 'tourlane.de', 'tourlane.nl', 'tourlane.fr', 'tlservers.de', 'tlservers.com', 'tlservers.co.uk', 'tlservers.nl', 'tlservers.fr', 'localhost'];
export var tourlaneDomainRegExp = new RegExp(TOURLANE_DOMAINS.join('|'));
export var getDomain = function getDomain() {
  var _ref = window.location.host.match(tourlaneDomainRegExp) || ['localhost'],
      domain = _ref[0];

  return domain === 'localhost' ? '' : "." + domain;
};